<template>
    <v-sheet>
        <v-tabs v-model="levelThreeTab" color="primary" density="compact">
            <v-tab value="Detail">Detail</v-tab>
            <v-tab value="List">List</v-tab>
            <v-tab value="Subcontract">Subcontract</v-tab>
            <v-tab
                v-show="currentAssemblySafe.AssemblySeq == 0"
                value="AllOperations"
                >All Operations</v-tab
            >
        </v-tabs>

        <v-divider></v-divider>

        <v-window v-model="levelThreeTab" class="py-3">
            <v-window-item value="Detail">
                <DetailWindow />
            </v-window-item>

            <v-window-item value="List">
                <ListWindow />
            </v-window-item>

            <v-window-item value="Subcontract">
                <SubcontractWindow />
            </v-window-item>
            <v-window-item
                v-show="
                    currentAssemblySafe.AssemblySeq == 0 &&
                    levelThreeTab === 'AllOperations'
                "
                value="AllOperations"
            >
                <AllOperationsWindow />
            </v-window-item>
        </v-window>
    </v-sheet>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import DetailWindow from "./OperationsWindow/DetailWindow.vue";
import ListWindow from "./OperationsWindow/ListWindow.vue";
import SubcontractWindow from "./OperationsWindow/SubcontractWindow.vue";
import AllOperationsWindow from "./OperationsWindow/AllOperationsWindow.vue";
import { useJobEntryStore } from "../../../../../stores/ProjectManagement/JobEntry";
import { storeToRefs } from "pinia";

const jobEntryStore = useJobEntryStore();

const { levelThreeTab } = storeToRefs(jobEntryStore);

const currentAssemblySafe = computed(
    () => jobEntryStore.currentAssembly ?? { AssemblySeq: -1 }
);
</script>

<style scoped></style>
